import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import commonActions from '../../Actions/commonActions';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import useCustomerNavigation from "../../Hooks/Customer/useCustomerNavigation";
import Tabs from "../Tabs/Tabs";
import { useTabs } from "../../Hooks/Tabs/useTabs";

function Shortcuts({ userShortcuts }) {
  const { navigationItems } = useCustomerNavigation();
  const shortcutsObj = navigationItems();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const matchingShortcut = getMatchingShortcut(location.pathname, shortcuts);
    if (!matchingShortcut && activeTab) {
      setActiveTab(null);
    }
  }, [location.pathname]);
  
  const shortcuts = userShortcuts
    .map(id => Object.values(shortcutsObj).find(shortcut => shortcut.id === id))
    .filter(Boolean)
    .map((shortcut, idx) => ({
      ...shortcut,
      id: String(shortcut.id ?? idx),
      label: shortcut.label || `Shortcut ${idx + 1}`
    }));

  function getMatchingShortcut(currentPath, shortcuts) {
    return shortcuts.find(shortcut => {
      if (!shortcut.route) return false;
      return currentPath.endsWith(`${shortcut.route}`);
    });
  }

  const handleTabChange = (tab) => {
    if (tab && tab.route) {
      if (tab.redirect) {
        window.open(tab.route);
      } else {
        navigate(tab.route);
      }
      if (tab.onClick) tab.onClick();
    }
  };
  
  const { activeTab, setActiveTab } = useTabs(getMatchingShortcut(location.pathname, shortcuts));
  
  return (
    <Tabs
      tabs={shortcuts}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      onTabChange={handleTabChange}
    />
  );
}

function mapStateToProps(state) {
  return {
    externalUrls: state.CommonReducer.externalUrls,
    customer: state.CustomerReducer.customer,
    userShortcuts: state.CommonReducer.userShortcuts
  }
}

function mapDispatchToProps(dispatch) {
  return {
    commonActions: bindActionCreators(commonActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Shortcuts));
